import React, { useEffect, useState } from "react";
import "./JobStatus.css";
import { format } from "date-fns";
import axios from "axios";
import { Player } from "@lottiefiles/react-lottie-player";
import expiryAnimation from "../images/birthday_animated.json";
import ic_upcoming_birthdays from "../../images/ic_upcoming_birthdays.svg";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import bdayBg from "../../images/birthdayWish.png";
import user2 from "../../images/ic_no_person_photo.svg";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";

import on_duty from "../../images/on_duty_today.svg";
import vacation from "../../images/ic_vacation.svg";
import sickLeave from "../../images/ic_sick_leave.svg";
import dayOff from "../../images/ic_calendar.svg";
import WFH from "../../images/ic_wfh.svg";
import Btrip from "../../images/ic_business_trip.svg";
import ic_today from "../../images/ic_today.svg";
import TopCardPopUp from "./TopCardPopUp";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { Plus } from "lucide-react";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";
import { bgBG } from "@mui/material/locale";

const JobStatus2 = () => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const [birthdayCount, setBirthdayCount] = useState(null);
  const [birthdayList, setBirthdayList] = useState(null);
  const [birthdayImage, setBirthdayImage] = useState(null);
  const [showJobCardPopUp, setShowJobCardPopUp] = useState(false);
  const [popUpId, setPopUpId] = useState("");
  const [showBirthdayPopup, setShowBirthdayPopup] = useState(false);
  const [leaveCount, setLeaveCount] = useState(null);
  const [base_url, setBaseUrl] = useState(`${base_url_from_axios_config}/`);

  const openJobCardModal = (id) => {
    setShowJobCardPopUp(true);
    setPopUpId(id);
  };

  const closeJobCardModal = () => {
    setShowJobCardPopUp(false);
  };

  // Find the Sick Leave count from the API response
  const sickLeaveCount =
    leaveCount?.find((leave) => leave.leave_key === "Sick Leave")?.count || 0;

  const vacationCount =
    leaveCount?.find((leave) => leave.leave_key === "On Vacation")?.count || 0;

  const wfhCount =
    leaveCount?.find((leave) => leave.leave_key === "Work From Home")?.count ||
    0;

  const dayOffCount =
    leaveCount?.find((leave) => leave.leave_key === "Day Off")?.count || 0;

  const businessTripCount =
    leaveCount?.find((leave) => leave.leave_key === "Business Trip")?.count ||
    0;

  useEffect(() => {
    // Format the current date as needed
    const today = format(new Date(), "yyyy-MMM-dd");

    const apiUrl = `${base_url}api/HRDashboard/${companyCode}/-/LEAVECOUNT/${today}/${today}/-/-/-/-/-`;

    console.log("apiUrl-JobStatus", apiUrl);

    // Fetch data from the API
    const fetchLeaveCount = async () => {
      try {
        const response = await axios.get(apiUrl);
        setLeaveCount(response.data);
        console.log("apiUrl-JobStatus-response", response);
      } catch (error) {
        console.error("Error fetching leave count:", error);
      }
    };

    const apiUrlBirthday = `${base_url}api/cpayscount/${companyCode}/birthday/-/-`;
    const apiUrlBirthdayList = `${base_url}api/cpayscount/${companyCode}/BIRTHDAYLIST/-/-`;
    // https://cubixweberp.com:213/api/cpayscount/cubix/BIRTHDAYLIST/-/-

    const callBirthday = async () => {
      try {
        const response = await axios.get(apiUrlBirthday);
        setBirthdayCount(response.data[0]?.Column1);
      } catch (error) {
        console.error("Error fetching bday count:", error);
      }
    };
    // const callBirthdayList = async () => {
    //   try {
    //     const response = await axios.get(apiUrlBirthdayList);
    //     setBirthdayList(response.data);
    //     setBirthdayImage(response.data[0].imagepath.split("\\").pop());
    //     // console.log('bday List response',response.data)
    //     console.log(
    //       "bday List response",
    //       response.data[0].imagepath.split("\\").pop(),
    //     );
    //   } catch (error) {
    //     console.error("Error fetching birthday List:", error);
    //   }
    // };

    const callBirthdayList = async () => {
      try {
        const response = await axios.get(apiUrlBirthdayList);

        const data = response.data || [];
        setBirthdayList(data);

        console.log("bday List response", data);
      } catch (error) {
        console.error("Error fetching birthday List:", error);
      }
    };

    if (base_url) {
      fetchLeaveCount();
      callBirthday();
      callBirthdayList();
    }
  }, [base_url]);

  const onBirthdayPopup = () => {
    setShowBirthdayPopup(true);
  };

  const fetchProfilePic = (ImagePath) => {
    if (!ImagePath) return user2;
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split("/").pop();
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  return (
    <div>
      {birthdayCount !== 0 ? (
        <button onClick={onBirthdayPopup}>
          <span className="flex flex-col items-center">
            <p className="bg-[#ededed] px-2 py-1 rounded-[9px] text-xs relative flex items-center">
              <label className="text-[#4C7FC8] text-[16px] font-extrabold mx-1">
                {birthdayCount}
              </label>
              <img
                className="w-[80px]"
                src={ic_upcoming_birthdays}
                alt="Upcoming birthdays"
              />
              <span className="ml-1 w-0 h-0 border-y-[7px] border-y-transparent border-l-[11px] border-l-[#c7c7c7]"></span>
            </p>
            <Player
              src={expiryAnimation}
              speed={0.5}
              loop
              autoplay
              style={{ width: 90, height: 80 }}
            />
          </span>
        </button>
      ) : (
        // <img src={ic_today} className="w-[100px]" alt="Today's icon" />
        // <img src={''} className="w-[100px]" alt="Today's icon" />
        <div></div>
      )}
{showBirthdayPopup && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
    
    {/* Card */}
    <div className="w-full max-w-[440px] max-h-[120vh] 
                    bg-[#2663EB] rounded-3xl shadow-2xl 
                    overflow-hidden relative flex flex-col">

      {/* Close Button */}
      <button
        onClick={() => setShowBirthdayPopup(false)}
        className="absolute top-3 right-3 z-20 w-8 h-8 
                   flex items-center justify-center 
                   rounded-full bg-white hover:bg-gray-200 
                   text-gray-600 transition"
      >
        ✕
      </button>

      {/* 🔥 Banner (Fixed Height) */}
      <div className="h-120 w-full flex-shrink-0">
        <img
          src={bdayBg}
          alt="Birthday Banner"
          className="w-full h-full object-cover"
        />
      </div>

      {/* 🔥 Scrollable Content Area */}
      <div className="h-60 overflow-y-auto p-3 scrollbar-none">

        {birthdayList?.map((birthdayListItem, index) => {
          const imageName = birthdayListItem?.imagepath
            ? birthdayListItem.imagepath.split("\\").pop()
            : null;

          return (
            <div className=" ">
            <div
              key={index}
              className="flex flex-col items-center text-center"
            >
              <div
                className="w-28 h-28 rounded-full overflow-hidden 
                           border-4 border-white shadow-xl bg-white"
              >
                <img
                  src={
                    imageName
                      ? fetchProfilePic(imageName)
                      : "/images/default-avatar.png"
                  }
                  alt={birthdayListItem?.Name}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.src = "/images/default-avatar.png";
                  }}
                />
              </div>

              <h3 className="text-lg font-semibold text-white ">
                {birthdayListItem?.Name}
              </h3>

              <p className="text-sm text-gray-200">
                {birthdayListItem?.EmpId}
              </p>

              <p className="text-sm text-gray-200">
                {birthdayListItem?.JobTitle}
              </p>

              <p className="text-sm text-yellow-300 font-semibold my-2">
                🎂 {birthdayListItem?.Birth_Day}
              </p>
            </div>
            </div>
          );
        })}

      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default JobStatus2;

{
  /*   <>
      <div className="flex flex-row justify-center items-center w-full overflow-x-auto scrollbar-hide">
        {/* <div className="flex flex-row justify-end items-center gap-5 w-full mb-4"> 
        <div className="grid grid-cols-2 gap-2 w-full mb-4">
          {birthdayCount != 0 ? (
            <span className="flex items-center">
              <p className="bg-[#ededed] px-2 py-1 rounded-[9px] text-xs relative flex items-center">
                <label className="text-[#4C7FC8] text-[16px] font-extrabold mx-1">
                  {birthdayCount}
                </label>
                <img className="w-[80px]" src={ic_upcoming_birthdays} />
                <span className="ml-1 w-0 h-0 border-y-[7px] border-y-transparent border-l-[11px] border-l-[#c7c7c7]"></span>
              </p>
              <Player
                src={expiryAnimation}
                speed={0.5}
                loop={true}
                autoplay={true}
                style={{ width: 90, height: 80 }}
              />
            </span>
          ) : (
            // <img src={ic_today} className="w-[100px]" />
            <img src={''} className="w-[100px]" />
          )}
<div></div>
          <div className="p-3 h-[62px] rounded-md text-[#2395a0] text-sm flex items-center cursor-pointer   bg-transparent border">
            <div className="flex items-center">
              <img className="w-[22px] pl-1 mr-1" src={on_duty} />
              On duty-Today
            </div>
            <div className="font-bold text-lg flex items-center ml-2">
              {leaveCount?.filter(
                (item) => item.leave_key === "On duty-Today"
              )[0]?.count || 0}
            </div>
          </div>

          <div className="p-3 h-[62px] rounded-md text-[#2395a0] text-sm flex items-center cursor-pointer   bg-transparent border">
            <div className="flex items-center">
              <img className="w-[22px] pl-1 mr-1" src={vacation} />
              On Vacation
            </div>
            <div className="font-bold text-lg flex items-center ml-2">
              {leaveCount?.filter((item) => item.leave_key === "On Vacation")[0]
                ?.count || 0}
            </div>
          </div>

          <div className="p-3 h-[62px] rounded-md text-[#2395a0] text-sm flex items-center cursor-pointer   bg-transparent border">
            <div className="flex items-center">
              <img className="w-[22px] pl-1 mr-1" src={WFH} />
              Work From Home
            </div>
            <div className="font-bold text-lg flex items-center ml-2">
              {leaveCount?.filter(
                (item) => item.leave_key === "Work from Home"
              )[0]?.count || 0}
            </div>
          </div>

          <div className="p-3 h-[62px] rounded-md text-[#2395a0] text-sm flex items-center cursor-pointer   bg-transparent border">
            <div className="flex items-center">
              <img className="w-[22px] pl-1 mr-1" src={sickLeave} />
              Sick Leave
            </div>
            <div className="font-bold text-lg flex items-center ml-2">
              {leaveCount?.filter((item) => item.leave_key === "Sick Leave")[0]
                ?.count || 0}
            </div>
          </div>

          <div className="p-3 h-[62px] rounded-md text-[#2395a0] text-sm flex items-center cursor-pointer   bg-transparent border">
            <div className="flex items-center">
              <img className="w-[22px] pl-1 mr-1" src={dayOff} />
              Day Leave
            </div>
            <div className="font-bold text-lg flex items-center ml-2">
              {leaveCount?.filter((item) => item.leave_key === "Day Leave")[0]
                ?.count || 0}
            </div>
          </div>

          <div className="p-3 h-[62px] rounded-md text-[#2395a0] text-sm flex items-center cursor-pointer   bg-transparent border">
            <div className="flex items-center">
              <img className="w-[22px] pl-1 mr-1" src={Btrip} />
              Business Trip
            </div>
            <div className="font-bold text-lg flex items-center ml-2">
              {leaveCount?.filter(
                (item) => item.leave_key === "Business Trip"
              )[0]?.count || 0}
            </div>
          </div>
        </div>
      </div> */
}

{
  /* <TopCardPopUp
        showJobCardPopUp={showJobCardPopUp}
        closeJobCardModal={closeJobCardModal}
        popUpId={popUpId}
      /> */
}
//       );
// };

// export default JobStatus2;
